export default __webpack_public_path__ + "images/0x8e38179d361402f6a94767757e807146609e9b3d.png";